// extracted by mini-css-extract-plugin
export default {"card":"Card_card__f+9dW","value":"Card_value__0Ye9x","name":"Card_name__Df5jn"};